import React from 'react';
import './PriorityBadge.scss';

export interface PriorityBadgeProps {
  position: number;
  className?: string;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({
  position,
  className = ''
}) => {
  return (
    <span
      className={`cmx-priority-badge ${className}`.trim()}
      aria-label={`Priority ${position}`}
      data-testid="priority-badge"
    >
      {position}
    </span>
  );
};

PriorityBadge.displayName = 'PriorityBadge';
export default PriorityBadge;
